/* ==========================================================================
   rv page system — WhatsApp expert touchpoints (handoff Addendum A3).
   Loaded as a module by snippets/rv-head.liquid, only when WhatsApp is enabled with a number
   (a module URL is evaluated once).
   1. The options in the prefilled message follow the selected variant (core event `rv:variant`): every product
      option with 2+ values, with its own name, e.g. " (Size: Regular)" (snippets/rv-whatsapp-url.liquid).
   2. Floating button: raised while the sticky bar shows (`rv:sticky`), hidden while the size guide is open
      (`rv:sizeguide`); the body classes rv-sticky-visible / rv-sizeguide-open do the same in CSS.
   3. Click tracking: dataLayer + Shopify customer events (`whatsapp_click`, {location}).
   ========================================================================== */
(() => {
  if (window.__rvWhatsApp) return;
  window.__rvWhatsApp = true;
  const d = document;
  const all = (sel) => d.querySelectorAll(sel);

  /* Options with 2+ values (product JSON of the core): [index, name] pairs, as rv-whatsapp-url.liquid. */
  const multi = () => {
    const p = window.RV && RV.product;
    if (!p || !p.options || !p.variants) return [];
    return p.options
      .map((name, i) => [i, name])
      .filter(([i]) => new Set(p.variants.map((v) => v.options[i])).size > 1);
  };
  const esc = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  const sync = (variant) => {
    const opts = multi();
    if (!variant || !variant.options || !opts.length) return;
    /* Trailing "(Name: value[, Name: value])" written by the server or a previous sync, for these option names only. */
    const old = new RegExp('\\s*\\((?:' + opts.map(([, n]) => esc(n)).join('|') + '): [^)]*\\)$');
    const tail = opts.map(([i, n]) => `${n}: ${variant.options[i]}`).join(', ');
    all('a[data-rv-wa]').forEach((a) => {
      try {
        const u = new URL(a.href);
        const text = `${(u.searchParams.get('text') || '').replace(old, '')} (${tail})`.trim();
        a.href = `${u.origin}${u.pathname}?text=${encodeURIComponent(text)}`;
      } catch (e) {
        /* keep the server-rendered href */
      }
    });
  };

  d.addEventListener('rv:variant', (e) => sync(e.detail && e.detail.variant));
  /* Theme editor re-renders a section with the initial variant: re-apply the current one. */
  d.addEventListener('shopify:section:load', () => sync(window.RV && RV.variant));
  sync(window.RV && RV.variant);

  const floats = (cls, on) => all('.rv-wa-float').forEach((f) => f.classList.toggle(cls, on));
  d.addEventListener('rv:sticky', (e) => floats('is-raised', !!(e.detail && e.detail.visible)));
  d.addEventListener('rv:sizeguide', (e) => floats('is-hidden', !!(e.detail && e.detail.open)));

  d.addEventListener('click', (e) => {
    const a = e.target.closest && e.target.closest('a[data-rv-wa]');
    if (!a) return;
    const location = a.dataset.rvWaLocation || 'unknown';
    try {
      if (window.dataLayer) window.dataLayer.push({ event: 'whatsapp_click', location });
    } catch (err) {}
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish('whatsapp_click', { location });
      }
    } catch (err) {}
  });
})();
